import { TextField, FormControl } from '@mui/material';
import React from 'react';

const CustomInput = ({ formik, label, name, ...rest }) => {
    return (
        <FormControl fullWidth>
            <TextField
                id={name}
                name={name}
                label={label}
                variant="outlined"
                value={formik?.values[name]}
                onChange={formik?.handleChange}
                onBlur={formik?.handleBlur}
                error={formik?.touched[name] && !!formik.errors[name]}
                helperText={formik?.touched[name] && formik.errors[name] ? formik.errors[name] : ""}
                fullWidth
                {...rest}
            />
        </FormControl>
    );
};

export default CustomInput;
